module.exports = __webpack_public_path__ + "img/product-vtd-application.0aef82f1.png";